<template>
  <div class="presensi-camera">
    <!-- sisi kamera -->
    <div class="camera-view">
      <video class="camera-stream" ref="video" autoplay></video>
      <!-- button untuk capture gambar -->
      <button v-if="!isCaptured" class="button-camera" @click="capture">
        <svg
          width="28"
          height="22"
          viewBox="0 0 28 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5714 19.0001C26.5714 19.6063 26.3306 20.1877 25.902 20.6163C25.4733 21.045 24.8919 21.2858 24.2857 21.2858H3.7143C3.10809 21.2858 2.52671 21.045 2.09806 20.6163C1.6694 20.1877 1.42859 19.6063 1.42859 19.0001V6.42864C1.42859 5.82243 1.6694 5.24105 2.09806 4.8124C2.52671 4.38374 3.10809 4.14293 3.7143 4.14293H8.28573L10.5714 0.714355H17.4286L19.7143 4.14293H24.2857C24.8919 4.14293 25.4733 4.38374 25.902 4.8124C26.3306 5.24105 26.5714 5.82243 26.5714 6.42864V19.0001Z"
            stroke="#FCFCFC"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14 16.7144C16.5247 16.7144 18.5714 14.6677 18.5714 12.1429C18.5714 9.6182 16.5247 7.5715 14 7.5715C11.4753 7.5715 9.42859 9.6182 9.42859 12.1429C9.42859 14.6677 11.4753 16.7144 14 16.7144Z"
            stroke="#FCFCFC"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <!-- end of button untuk capture gambar -->

      <!-- button untuk retake -->
      <button v-else class="button-camera" @click="retake">
        <svg
          width="24"
          height="23"
          viewBox="0 0 24 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.571472 2.28159V9.12088M0.571472 9.12088H7.42861M0.571472 9.12088L5.87433 4.151C7.45251 2.57958 9.49999 1.56229 11.7082 1.25241C13.9165 0.942531 16.1659 1.35684 18.1176 2.43293C20.0692 3.50901 21.6174 5.18857 22.5288 7.21853C23.4401 9.2485 23.6654 11.5189 23.1706 13.6877C22.6758 15.8564 21.4877 17.806 19.7853 19.2428C18.083 20.6795 15.9586 21.5255 13.7323 21.6533C11.506 21.7811 9.2983 21.1838 7.44194 19.9513C5.58557 18.7189 4.18106 16.9181 3.44004 14.10243"
            stroke="#FCFCFC"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <!-- end of retake -->
    </div>
    <!-- end of sisi kamera -->

    <!-- sisi data presensi -->
    <div class="presensi-view">
      <div class="view-title">
        <h3>Presensi Kehadiran</h3>
        <p>Presensi wajib menyertakan foto dan lokasi</p>
      </div>

      <div class="tanggal-presensi">
        <!-- detail absensi masuk -->
        <div v-if="!userData.tanggalAbsensi.selesai">
          <h2>
            {{
              userData.tanggalAbsensi.mulai
                ? userData.tanggalAbsensi.mulai
                : "---"
            }}
            <span style="color: #eb5757; margin-left: 20px"
              >{{
                userData.jamAbsensi.mulai
                  ? userData.jamAbsensi.mulai
                  : "-- : -- : -- "
              }}
              WIB</span
            >
          </h2>
          <p>
            {{
              userData.alamatAbsensi.mulai
                ? userData.alamatAbsensi.mulai
                : "-----"
            }}
          </p>
        </div>
        <!-- end of detail absensi masuk -->

        <!-- detail absensi selesai -->
        <div v-else>
          <h2>
            {{
              userData.tanggalAbsensi.selesai
                ? userData.tanggalAbsensi.selesai
                : "---"
            }}
            <span style="color: #eb5757; margin-left: 20px"
              >{{
                userData.jamAbsensi.selesai
                  ? userData.jamAbsensi.selesai
                  : "-- : -- : -- "
              }}
              WIB</span
            >
          </h2>
          <p>
            {{
              userData.alamatAbsensi.selesai
                ? userData.alamatAbsensi.selesai
                : "-----"
            }}
          </p>
        </div>
        <!-- end of detail absensi masuk -->

        <!-- presensi masuk -->
        <button
          v-if="!isMulai"
          @click="presensi"
          :disabled="!isCaptured || isProcessing"
          class="yellow-button"
        >
          <div ref="spinner" style="display: none" class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
          <span ref="button-presensi-text"> Presensi masuk</span>
        </button>
        <!-- presensi pulang -->
        <button
          v-else
          @click="presensi"
          :disabled="!isCaptured || isProcessing || isSelesai"
          class="yellow-button"
        >
          <div ref="spinner" style="display: none" class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
          <span ref="button-presensi-text"> Presensi pulang</span>
        </button>
      </div>

      <!-- waktu kerja -->
      <div class="presensi-waktu-kerja">
        <!-- mulai kerja -->
        <div class="waktu-presensi">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="20" cy="20" r="20" fill="#00BA88" />
            <path
              d="M20 15V25M20 25L25 20M20 25L15 20"
              stroke="#FCFCFC"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div class="data-waktu">
            <h4>Mulai Kerja</h4>
            <p>
              {{ mulaiKerja ? mulaiKerja : "-- : -- : --" }}
            </p>
          </div>
        </div>

        <!-- selesai kerja -->
        <div class="waktu-presensi">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="20" cy="20" r="20" fill="#EB5757" />
            <path
              d="M20 25V15M20 15L15 20M20 15L25 20"
              stroke="#FCFCFC"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <div class="data-waktu">
            <h4>Selesai Kerja</h4>
            <p>
              {{ selesaiKerja ? selesaiKerja : "-- : -- : --" }}
            </p>
          </div>
        </div>
      </div>
      <!-- end of waktu kerja -->
    </div>
    <!-- end of sisi data presensi -->

    <!-- modal alert berhasil -->
    <Modal v-if="modalIsOpen">
      <div class="content">
        <svg
          style="margin-bottom: 28px"
          width="88"
          height="88"
          viewBox="0 0 88 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="44" cy="44" r="44" fill="#00BA88" />
          <path
            d="M64.9526 42.0841V44.0117C64.95 48.53 63.487 52.9263 60.7817 56.5451C58.0764 60.1639 54.2738 62.8112 49.941 64.0923C45.6082 65.3734 40.9773 65.2195 36.7391 63.6537C32.5009 62.0879 28.8824 59.194 26.4232 55.4037C23.964 51.6133 22.796 47.1296 23.0933 42.6212C23.3906 38.1127 25.1372 33.8212 28.0728 30.3866C31.0084 26.9519 34.9756 24.5583 39.3827 23.5625C43.7899 22.5668 48.4008 23.0223 52.5279 24.8613M64.9526 27.2499L44.0002 48.2232L37.7145 41.9375"
            stroke="#FCFCFC"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <div class="text-modal">
          <h2 class="primary-text">{{ userData.nama }}</h2>
          <h3 class="divisi-no">
            DIVISI: {{ userData.divisi }} <span>|</span> NO PEGAWAI:
            {{ userData.noPegawai }}
          </h3>
          <!-- ketika absen masuk -->
          <div v-if="!userData.jamAbsensi.selesai" class="tanggal-alamat">
            <p class="tanggal">
              {{ userData.tanggalAbsensi.mulai }} | Pukul
              {{ userData.jamAbsensi.mulai }}
            </p>
            <p class="alamat">{{ userData.alamatAbsensi.mulai }}</p>
          </div>
          <!-- ketika absen pulang -->
          <div v-else class="tanggal-alamat">
            <p class="tanggal">
              {{ userData.tanggalAbsensi.selesai }} | Pukul
              {{ userData.jamAbsensi.selesai }}
            </p>
            <p class="alamat">{{ userData.alamatAbsensi.selesai }}</p>
          </div>
        </div>
      </div>

      <!-- close button -->
      <svg
        @click="closeModal"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </Modal>
    <!-- end of modal alert berhasil -->

    <!-- modal untuk yang sudah absen secara penuh -->
    <ModalAbsenPenuh v-if="modalAbsenPenuhlIsOpen">
      <!-- icon modal -->
      <template v-slot:icon>
        <svg
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="44.5" cy="44" r="44" fill="#00BA88" />
          <path
            d="M65.4526 42.4193V44.347C65.4501 48.8655 63.987 53.2621 61.2817 56.8811C58.5764 60.5001 54.7738 63.1476 50.441 64.4287C46.1082 65.7099 41.4774 65.556 37.2391 63.9901C33.0009 62.4242 29.3824 59.5302 26.9232 55.7396C24.464 51.9491 23.296 47.4651 23.5933 42.9564C23.8906 38.4477 25.6372 34.1559 28.5728 30.7211C31.5084 27.2863 35.4756 24.8924 39.8827 23.8967C44.2899 22.9009 48.9008 23.3565 53.0279 25.1955M65.4526 27.5842L44.5002 48.5587L38.2145 42.2727"
            stroke="#FCFCFC"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
      <!-- text modal -->
      <template v-slot:text>
        <h2>Sudah melakukan absen secara penuh</h2>
        <p>Silakan ke riwayat untuk melihat data absen</p>
        <button
          @click="gotToRiwayat"
          style="margin-top: 28px"
          class="button-login"
        >
          Ke riwayat
        </button>
      </template>
    </ModalAbsenPenuh>
    <!-- end of modal untuk yang sudah absen secara penuh -->

    <!-- modal gagal -->
    <ModalGagal v-if="modalGagalIsOpen">
      <!-- icon modal -->
      <template v-slot:icon>
        <svg
          width="88"
          height="88"
          viewBox="0 0 88 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M42.2679 11.8001C43.0377 10.4667 44.9622 10.4667 45.7321 11.8L80.3731 71.8C81.1429 73.1334 80.1806 74.8 78.641 74.8H9.35899C7.81939 74.8 6.85713 73.1334 7.62693 71.8L42.2679 11.8001Z"
            fill="#EB5757"
          />
          <path
            d="M46.4196 35.2L45.6276 57.1999H40.3916L39.5996 35.2H46.4196ZM46.3756 61.0719V67.54H39.6876V61.0719H46.3756Z"
            fill="#FCFCFC"
          />
        </svg>
      </template>
      <!-- text modal -->
      <template v-slot:text>
        <h2>
          {{ pesanError }}
        </h2>
      </template>
      <!-- close button -->
      <template v-slot:close>
        <svg
          @click="openCloseModalGagal(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </ModalGagal>
    <!-- end of modal gagal -->
  </div>
</template>

<script>
import Modal from "@/components/modal/Modal";
import ModalGagal from "@/components/modal/ModalAlert";
// firebase
import * as soluhaFire from "@/soluhafire";
import { mapState } from "vuex";
import { gmapApi } from "vue2-google-maps";
import * as soluhaApi from "@/soluhaApi";
import ModalAbsenPenuh from "@/components/modal/ModalAlert";

export default {
  components: {
    Modal,
    ModalAbsenPenuh,
    ModalGagal,
  },

  data() {
    return {
      isProcessing: false,
      isMulai: false,
      isSelesai: false,
      gambar: null,
      alamat: "",
      coordinates: null,
      modalIsOpen: false,
      // set view video camera
      hdConstraints: {
        video: {
          width: {
            exact: 320,
          },
          height: {
            exact: 380,
          },
        },
      },
      // object video stream
      mediaStream: null,
      // cek apakah sudah capture gambar ?
      isCaptured: false,
      tempAlamat: "",
      // status modal
      modalAbsenPenuhlIsOpen: false,
      modalGagalIsOpen: false,
      pesanError: "",
      // waktu
      mulaiKerja: "",
      selesaiKerja: "",
    };
  },

  methods: {
    // ambil gambar
    capture() {
      const mediaStreamTrack = this.mediaStream.getVideoTracks()[0];
      const imageCapture = new window.ImageCapture(mediaStreamTrack);
      return imageCapture.takePhoto().then((blob) => {
        this.gambar = blob;
        // pause video
        this.$refs.video.pause();
        this.isCaptured = true;
      });
    },

    // retake camera
    retake() {
      this.$refs.video.play();
      this.isCaptured = false;
    },

    async geocoding() {
      await this.$gmapApiPromiseLazy();
      // reverse geocode
      let geocoder = new this.google.maps.Geocoder();
      let alamat;
      // ada 8 hasil geocode, yang [0] paling lengkap :)
      geocoder.geocode({ location: this.coordinates }, (result, status) => {
        if (status !== "OK") return;
        if (!result[0]) return;

        alamat = `${result[0].address_components[0].long_name} ${result[0].address_components[2].long_name} ${result[0].address_components[3].long_name}`;
        alamat = alamat.toUpperCase();
        // cek apakah sudah absen mulai kerja
        if (!this.userData.alamatAbsensi.mulai) {
          this.userData.alamatAbsensi.mulai = alamat;
        } else {
          this.userData.alamatAbsensi.selesai = alamat;
        }
        this.modalIsOpen = true;
      });
    },

    // presensi
    async presensi() {
      this.loader(true);
      // kirim data ke server
      let result = soluhaApi.presensi(this.gambar, this.coordinates);
      result
        .then((response) => {
          // cek apakah sudah absen mulai kerja
          if (!this.userData.jamAbsensi.mulai) {
            this.userData.jamAbsensi.mulai = soluhaFire.getServerClockTime();
            this.userData.tanggalAbsensi.mulai = soluhaFire.getDate();
            this.mulaiKerja = this.userData.jamAbsensi.mulai;
            this.isMulai = true;
            this.retake();
          } else {
            this.userData.jamAbsensi.selesai = soluhaFire.getServerClockTime();
            this.userData.tanggalAbsensi.selesai = soluhaFire.getDate();
            this.selesaiKerja = this.userData.jamAbsensi.selesai;
            this.isSelesai = true;
          }
          // presensi berhasil
          this.geocoding();
          this.loader(false);
          console.log(response);
        })
        .catch((error) => {
          // presensi gagal
          error = "Tidak ada shift untuk hari ini";
          this.loader(false);
          this.openCloseModalGagal(true, error);
        });
    },
    // tutup modal
    closeModal() {
      this.modalIsOpen = false;
    },
    stopCameraStream() {
      if (this.mediaStream) {
        this.mediaStream.getTracks()[0].stop();
      }
    },

    // buka atau tutup modal gagal
    openCloseModalGagal(isOpen, error) {
      if (isOpen) {
        this.pesanError = error;
        this.modalGagalIsOpen = true;
      } else {
        this.pesanError = "";
        this.modalGagalIsOpen = false;
      }
    },

    // ambil data presensi hari ini
    async getTodayPresensi() {
      // button dalam proses
      let listPresensi = this.userData.riwayatPresensi;
      // get epoch time
      let today = soluhaFire.getServerEpoch();
      // get date
      today = soluhaApi.epochToDate(today);

      // filter listPresensi untuk ambil yang hari ini
      listPresensi = listPresensi.filter(
        (presensi) => soluhaApi.epochToDate(presensi.masukTime.seconds) == today
      );

      // ada presensi yang telah dilakukan hari ini
      if (listPresensi[0]) {
        // ketika udah presensi masuk
        if (listPresensi[0].masukTime) {
          this.mulaiKerja = soluhaFire.epochToClock(
            listPresensi[0].masukTime.seconds
          );
          this.isMulai = true;
          this.userData.jamAbsensi.mulai = "-- : -- : -- ";
          this.userData.tanggalAbsensi.mulai = "---";
          this.userData.alamatAbsensi.mulai = "-----";
        }
        // ketika udah presensi keluar
        if (listPresensi[0].keluarTime) {
          this.selesaiKerja = soluhaFire.epochToClock(
            listPresensi[0].keluarTime.seconds
          );
          this.userData.jamAbsensi.selesai = "-- : -- : -- ";
          this.userData.tanggalAbsensi.selesai = "---";
          this.userData.alamatAbsensi.selesai = "-----";
          // buka modal
          this.modalAbsenPenuhlIsOpen = true;
        }
      }
    },

    gotToRiwayat() {
      this.$emit("changeComponent", "Riwayat");
    },

    loader(isLoading) {
      let textButton = this.$refs["button-presensi-text"];
      let spinner = this.$refs["spinner"];
      if (isLoading) {
        this.isProcessing = true;
        textButton.style.display = "none";
        spinner.style.display = "block";
      } else {
        this.isProcessing = false;
        textButton.style.display = "block";
        spinner.style.display = "none";
      }
    },
  },

  mounted() {
    this.loader(true);
    // ambil presensi hari ini
    setTimeout(() => {
      this.getTodayPresensi();
      this.loader(false);
    }, 3000);

    const constraints = (window.constraints = {
      audio: false,
      video: {
        width: 320,
        heigth: 380,
      },
    });
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        this.mediaStream = stream;
        this.$refs.video.srcObject = stream;
      })
      .catch((error) => {
        console.log(
          "May the browser didn't support or there is some errors.",
          error
        );
      });

    // support geolocation, ambil gps user
    if (!("geolocation" in navigator)) {
      console.log("Geolocation is not available.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      function (pos) {
        this.coordinates = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
      }.bind(this),
      function errorCallback(error) {
        console.log(error);
      },
      {
        timeout: 5000,
        enableHighAccuracy: true,
      }
    );
  },

  computed: {
    ...mapState(["userData"]),
    google: gmapApi,
  },
};
</script>

<style scoped>
@import url("../../assets/css/hrd/presensiCamera.css");
</style>
